export default "__VITE_ASSET__JMuqLieGkTuy98pBWzN6FA__"